<template>
  <div class="register-form">
    <div class="item">
      <input
        type="text"
        name="name"
        v-model="user.phoneNum"
        maxlength="11"
        placeholder="请输入您的手机号"
        autocomplete="off"
        class="name"
      />
      <img class="icon" src="~@/assets/img/icon-phone.png" alt="" />
    </div>
    <div class="item code">
      <input
        type="text"
        name="vcode"
        v-model="user.verificationCode"
        maxlength="6"
        placeholder="请输入验证码"
        autocomplete="off"
        class="vcode"
      />
      <div class="send-code">
        <span v-if="disabled" style="background-color: #666666"
          >重新发送({{ count }})</span
        >
        <span v-else id="vcode" @click="sendCode">发送验证码</span>
      </div>
      <img class="icon" src="~@/assets/img/icon-code.png" alt="" />
    </div>
    <div class="item">
      <input
        type="password"
        v-model="user.password"
        name="password"
        placeholder="请设置您的密码"
        autocomplete="off"
        class="password"
      />
      <img class="icon" src="~@/assets/img/icon-setPassword.png" alt="" />
    </div>
    <div class="item">
      <input
        type="password"
        v-model="user.rePassword"
        name="passwordcf"
        placeholder="请确认您的密码"
        autocomplete="off"
        class="password"
      />
      <img class="icon" src="~@/assets/img/icon-setPassword.png" alt="" />
    </div>
    <div class="submit" @click="doRegister">
      <button>注册</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "RegisterFrom",
  data() {
    return {
      count: 60,
      disabled: false,
      user: {
        phoneNum: "",
        password: "",
        rePassword: "",
        verificationCode: "",
      },
      remember: false,
    };
  },
  methods: {
    sendCode() {
      if (!this.user.phoneNum) {
        this.$toast("请输入手机号码！");
      } else {
        if (!/^1[3456789]\d{9}$/.test(this.user.phoneNum)) {
          this.$toast("手机号码有误，请重填");
        } else {
          this.$http
            .post("/external/appUser/send/code", {
              phoneNum: this.user.phoneNum,
            })
            .then((res) => {
              if (res.code == 200) {
                this.disabled = true;
                this.$toast.success("发送成功，请注意查收！");
                let ts = setInterval(() => {
                  console.log(this.count, 12345);
                  this.count--;
                  if (this.count == 0) {
                    clearInterval(ts);
                    this.disabled = false;
                    this.count = 60;
                  }
                }, 1000);
              }
            });
        }
      }
    },
    doRegister() {
      if (
        !this.user.password ||
        !this.user.rePassword ||
        !this.user.phoneNum ||
        !this.user.verificationCode
      ) {
        this.$toast.error("请完善信息再提交！");
      } else {
        if (this.user.password != this.user.rePassword) {
          this.$toast.error("两次输入密码不一致，请修改！");
        } else {
          this.$http
            .post("/external/appUser/register", this.user)
            .then((res) => {
              if (res.code == 200) {
                this.$toast.success("注册成功！");
                this.$router.push("/login");
              } else {
                this.$toast.error(res.msg);
              }
            });
        }
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
